import { SitesBuilderLibComponent, Minimap } from '@3ddv/ngx-sites-builder-lib';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { SblibService } from '../../services/sblib.service';
import { ToolsService } from '../services/tools.service';

@Component({
  selector: 'app-sbeditor-tool-minimap',
  templateUrl: './minimap.component.html',
  styleUrls: ['./minimap.component.scss'],
})
export class MinimapComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription>;
  public tool: Minimap;
  public disablePositions: {
    bottom: boolean;
    top: boolean;
  } = {
      bottom: false,
      top: false,
    };
  constructor(
    private toolsService: ToolsService,
    private sblibService: SblibService,
    private toastrService: ToastrService
  ) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (res.minimap) {
        this.tool = JSON.parse(JSON.stringify(res.minimap));
        if (res.comparator && res.comparator.enabled) {
          this.disablePositions.bottom = true;
          this.disablePositions.top = false;
        }
        // console.log('Minimap tool: ', this.tool);
      } else {
        console.error('Minimap tool not found');
        return;
      }
    });
    this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public onSelect($event) { }

  public getTool() {
    // console.log('GetTool (Minimap): ', this.tool);
    return this.tool;
  }

  public onValueChange(type, id?) {
    if (this.disablePositions[type] === true) {
      this.toastrService.error(
        '',
        'Minimap > Bottom position not available if Popups > Comparator is enabled.'
      );
      return;
    }

    if (type === 'top') {
      this.tool.position.top = true;
      this.tool.position.bottom = false;
    } else if (type === 'bottom') {
      this.tool.position.top = false;
      this.tool.position.bottom = true;
    }
  }

  // public apply() {
  // const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
  //   res.minimap = JSON.parse(JSON.stringify(this.tool));
  //   this.sblibService.apply(res);
  //   this.toastrService.success('', 'Success');
  // });
  // this.subscriptions.push(tools$);
  // }
}
